import { render, staticRenderFns } from "./SearchTabTheme0.vue?vue&type=template&id=5bc642b2&scoped=true"
import script from "./SearchTabTheme0.vue?vue&type=script&lang=js"
export * from "./SearchTabTheme0.vue?vue&type=script&lang=js"
import style0 from "./SearchTabTheme0.vue?vue&type=style&index=0&id=5bc642b2&prod&scoped=true&lang=css"
import style1 from "./SearchTabTheme0.vue?vue&type=style&index=1&id=5bc642b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc642b2",
  null
  
)

export default component.exports